export const acceptedObjectIdToNameMap = {
  '0-1': 'contact',
  '0-2': 'company',
  '0-3': 'deal',
  '0-5': 'ticket',
  '0-27': 'task'
};
export const objectsAllowedToBeCreatedFromNav = new Set(['0-1', '0-2', '0-3', '0-5', '0-27']);
export const TASKS_CREATE_GATE = 'navigation:quickCreate:tasks';